import { Injectable } from "@angular/core";
import { Adapter } from "src/app/core/adapter";

export class Country {

    constructor(
        public label:string,
        public value: string,
    ) {}
}

    @Injectable({
        providedIn: "root"
    })

    export class CountryAdapter implements Adapter<Country> {
        adapt(item:any): Country {
            return new Country(item.countryName,item.countryId);
       }
    }

